import React, { useMemo } from 'react';
import { Box } from '@mui/system';
import Template from '@/components/dynamicComponent/Template';
import PageHeader from '@/components/PageHeader';
import { fieldGenerator } from '@/lib/dynamicTable';
import locale from 'antd/es/date-picker/locale/zh_TW';
import { useSelector } from 'react-redux';

export default function Property({ showHeader = true }) {
  const serviceData = useSelector((state) => state.service.serviceData);

  const serviceOptions = useMemo(() => {
    return serviceData.data.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [serviceData]);

  const dynamicStructure = useMemo(
    () => ({
      // Table 協力廠商名單
      dbName: 'menuPropertyVendor',
      text: '物業廠商名單',
      funcs: [
        {
          name: 'createData',
          text: '新增廠商',
          type: 'EditButton',
          deleteStatus: true,
        },
        { type: 'EditService' },
      ],
      fields: {
        // 各欄位的資料型態
        name: fieldGenerator('name', '廠商名稱'),
        service: fieldGenerator(
          'service',
          '服務類別',
          'Select',
          {
            mode: 'multiple',
            options: serviceOptions,
          },
          {},
          {
            width: 200,
            cell: (services) =>
              services
                .map(
                  (service) =>
                    serviceOptions.find((option) => option.value === service)
                      ?.label || ''
                )
                .join('、'),
          }
        ),
        address: fieldGenerator('address', '地址'),
        phone: fieldGenerator('phone', '電話'),
        createTime: fieldGenerator(
          'createTime',
          '建立時間',
          'hidden',
          {},
          {},
          { width: 200 }
        ),
        licenses: fieldGenerator(
          'licenses',
          '證照',
          'Upload',
          {
            multiple: true,
            accept: 'image/*',
          },
          {},
          { width: 400 }
        ),
        logo: fieldGenerator(
          'logo',
          '廠商圖片',
          'Upload',
          {
            maxCount: 1,
            accept: 'image/*',
          },
          {},
          {}
        ),
        contractFile: fieldGenerator(
          'contractFile',
          '合約檔',
          'Upload',
          {
            maxCount: 1,
            accept: '.pdf, image/*',
          },
          {},
          {}
        ),
        contractPeriod: fieldGenerator(
          'contractPeriod',
          '合約日期',
          'RangePicker',
          {
            locale,
            format: 'YYYY/MM/DD',
          },
          {},
          {
            width: 300,
          }
        ),
      },
      manipulate: [
        { name: 'editData', text: '編輯', type: 'EditButton' },
        {
          name: 'deleteData',
          text: '刪除',
          type: 'DeleteButton',
          deleteStatus: true,
        },
      ],
    }),
    [serviceOptions]
  );

  return (
    <Box>
      {/* header */}
      {showHeader && (
        <PageHeader
          title="物業廠商名單"
          breadcrumbs={[{ name: '組織管理' }, { name: '物業廠商名單' }]}
        />
      )}
      <Template {...{ dynamicStructure }} />
    </Box>
  );
}
